export default __webpack_public_path__ + "static/media/airbolt.f6dcb575.jpg";